import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { pick } from 'lodash';
import type { CreateAssetMutation, AssetInput } from '#/graphql/types';
import { createAsset } from '#/graphql/mutations';
import fields from '../utils/mutationDataFields';

const q = gql(createAsset);

const useAssetCreate = () => {
  const [mutation, result] = useMutation<CreateAssetMutation>(q);
  const createAsset = useCallback(
    async (asset: AssetInput) => {
      const response = await mutation({
        variables: {
          data: pick(asset, fields),
        },
      });
      return response.data?.createAsset?.data ?? undefined;
    },
    [mutation],
  );

  return { createAsset, result };
};

export default useAssetCreate;
